<template>
  <div class="contact-list">
    <div
      v-for="(item, index) in innerValue"
      :key="type + '-' + index"
      class="contact-list__row"
    >
      <el-input
        :value="innerValue[index]"
        :placeholder="placeholder"
        :maxlength="type === 'mobile' ? 11 : undefined"
        :disabled="disabled"
        @input="onInput(index, $event)"
      />
      <el-link
        v-if="innerValue.length > 1 && !disabled"
        type="primary"
        :underline="false"
        @click="removeItem(index)"
      >删除</el-link>
    </div>
    <el-button
      v-if="innerValue.length < max && !disabled"
      class="contact-list__add-btn"
      plain
      @click="addItem"
    >{{ addLabel }}</el-button>
    <p v-if="tip" class="contact-list__tip">{{ tip }}</p>
  </div>
</template>

<script>
export default {
  name: 'ContactList',
  props: {
    value: {
      type: Array,
      default: () => ['']
    },
    type: {
      type: String,
      default: 'email'
    },
    max: {
      type: Number,
      default: 5
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tip: {
      type: String,
      default: ''
    }
  },
  computed: {
    innerValue: {
      get () {
        return this.value && this.value.length ? this.value : ['']
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    placeholder () {
      return this.type === 'mobile' ? '请输入提醒接收手机号' : '请输入提醒接收邮箱地址'
    },
    addLabel () {
      return this.type === 'mobile' ? '添加手机号' : '添加邮箱地址'
    }
  },
  methods: {
    onInput (index, val) {
      const next = [...this.innerValue]
      next[index] = this.type === 'mobile' ? String(val).replace(/\D/g, '') : val
      this.innerValue = next
    },
    addItem () {
      if (this.innerValue.length >= this.max) return
      this.innerValue = [...this.innerValue, '']
    },
    removeItem (index) {
      if (this.innerValue.length <= 1) return
      const next = [...this.innerValue]
      next.splice(index, 1)
      this.innerValue = next
    }
  }
}
</script>

<style lang="scss" scoped>
.contact-list {
  &__row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;

    .el-input {
      flex: 1;
      max-width: 480px;
    }
  }

  &__add-btn {
    border-color: #409eff;
    color: #409eff;
  }

  &__tip {
    margin: 8px 0 0;
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
  }
}
</style>
